<template>
  <div class="ContactUs">
    <!-- 联系我们 Banner -->
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>联系我们</li>
        <li>绿色生态产业链全方位数据专家</li>
        <li></li>
      </ul>
    </div>
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span>首页&nbsp;></span>
          <span>联系我们</span>
        </div>
      </div>
    </div>
    <!-- 主要内容区 -->
    <div class="ContactUs_box" id="main-content">
      <div class="contentBox">
        <div class="contentBox_top">
          <!-- 左侧联系方式卡片 -->
          <div class="contentBox_topLeft">
            <div class="zxdh">
              <ul class="zxdh_box">
                <li><img src="@/assets/img/contactUs/dh.png" alt="" /></li>
                <li>咨询电话</li>
                <li>18190816379</li>
              </ul>
            </div>
            <div class="gsdz">
              <ul class="gsdz_box">
                <li><img src="@/assets/img/contactUs/gsdz.png" alt="" /></li>
                <li>公司地址</li>
                <li>四川省成都市青羊区人民南路一段86号城市之心18J</li>
              </ul>
            </div>
            <div class="dzyx">
              <ul class="dzyx_box">
                <li><img src="@/assets/img/contactUs/dzyx.png" alt="" /></li>
                <li>电子邮箱</li>
                <li>zhandongkj@163.com</li>
              </ul>
            </div>
          </div>
          <!-- 右侧联系方式表格 -->
          <ul class="contentBox_topRight">
            <li><div>区域</div><div>负责人</div><div>联系方式</div></li>
            <li v-for="(item, index) in contactInformationArr" :key="item.id">
              <div>{{ item.area }}</div>
              <div>{{ item.chargePerson }}</div>
              <div>{{ item.contactInformation }}</div>
            </li>
          </ul>
        </div>
        <!-- 地图容器 -->
        <div class="contentBox_bottom">
          <div id="map" style="width: 100%; height: 100%;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactInformation from '@/api/contactInformation.js'

// 天地图密钥（请替换为你自己的有效密钥）
const TIANDITU_KEY = '25c727f24ad93a67d9f0f0b2c10ba26c'

export default {
  name: 'ContactUs',
  data () {
    return {
      map: null,
      contactInformationArr: []
    }
  },
  methods: {
    /**
     * 动态加载天地图脚本
     */
    loadTiandituScript () {
      return new Promise((resolve, reject) => {
        if (window.T && window.T.Map) {
          resolve(window.T)
          return
        }
        if (document.getElementById('tianditu-script')) {
          const checkExist = setInterval(() => {
            if (window.T && window.T.Map) {
              clearInterval(checkExist)
              resolve(window.T)
            }
          }, 100)
          return
        }
        const script = document.createElement('script')
        script.id = 'tianditu-script'
        script.type = 'text/javascript'
        script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_KEY}`
        script.onload = () => {
          const checkReady = setInterval(() => {
            if (window.T && window.T.Map) {
              clearInterval(checkReady)
              resolve(window.T)
            }
          }, 100)
        }
        script.onerror = (err) => {
          console.error('天地图API加载失败:', err)
          this.$message.error('地图服务加载失败，请检查网络或密钥配置')
          reject(err)
        }
        document.head.appendChild(script)
      })
    },

    /**
     * 初始化地图（参照官方示例）
     */
    async initMap () {
      try {
        const T = await this.loadTiandituScript()
        const mapContainer = document.getElementById('map')
        if (!mapContainer) {
          console.error('地图容器不存在')
          this.$message.error('地图容器加载失败')
          return
        }

        // 创建地图实例
        this.map = new T.Map('map')
        const companyLocation = new T.LngLat(104.062750, 30.658200)
        this.map.centerAndZoom(companyLocation, 15) // 缩放级别调高，更清晰
        this.map.enableScrollWheelZoom()

        // 添加公司位置标记（使用官方推荐方法）
        this.addCompanyMarker(companyLocation)
        console.log('天地图初始化成功')
      } catch (error) {
        console.error('地图初始化失败:', error)
        this.$message.error('地图加载失败，请刷新页面重试')
      }
    },

    /**
     * 添加公司标记点（完全参照官方示例的写法）
     */
    addCompanyMarker (point) {
      const T = window.T
      if (!T || !this.map) return

      // 创建标记（先使用默认图标，确保功能正常；如需自定义图标可后续添加）
      const marker = new T.Marker(point)

      // 官方方法：使用 addOverLay 将标记添加到地图
      this.map.addOverLay(marker)

      // 信息窗口内容（支持HTML）
      const infoContent = `
        <div style="padding: 8px; font-family: 'Source Han Sans CN', sans-serif; min-width: 220px;">
          <h4 style="margin: 0 0 8px 0; color: #1c7e28; font-size: 16px;">四川展东科技有限公司</h4>
          <p style="margin: 5px 0; font-size: 13px; line-height: 1.5;">🏢 地址：四川省成都市青羊区人民南路一段86号城市之心18J</p>
          <p style="margin: 5px 0; font-size: 13px; line-height: 1.5;">📞 电话：18190816379</p>
          <p style="margin: 5px 0; font-size: 13px; line-height: 1.5;">✉️ 邮箱：zhandongkj@163.com</p>
        </div>
      `

      // 为标记绑定点击事件，打开信息窗口
      marker.addEventListener('click', (e) => {
        // 关键：使用点击事件的经纬度 e.lnglat 打开信息窗口（与官方示例一致）
        const infoWindow = new T.InfoWindow(infoContent, {
          offset: new T.Point(0, -30)
        })
        this.map.openInfoWindow(infoWindow, e.lnglat)
      })
    },

    /**
     * 获取联系方式列表（后端接口）
     */
    async getContactInformationList () {
      try {
        const params = { startTime: '', endTime: '', page: 1, pageSize: 10 }
        const { code, msg, data } = await ContactInformation.queryList(params)
        if (code === 200) {
          this.contactInformationArr = data.filter((item) => item.enabled === 1)
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        console.error('获取联系方式失败:', error)
      }
    }
  },
  mounted () {
    // 确保 DOM 完全渲染后再初始化地图
    this.$nextTick(() => {
      this.initMap()
    })
    this.getContactInformationList()

    // 自动滚动到面包屑下方（保留原有交互）
    // this.$nextTick(() => {
    //   const mainContent = document.getElementById('main-content')
    //   if (mainContent) {
    //     const breadcrumb = document.querySelector('.breadcrumb')
    //     const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48
    //     const bannerHeight = 274
    //     window.scrollTo({
    //       top: bannerHeight + breadcrumbHeight - 10,
    //       behavior: 'smooth'
    //     })
    //   }
    // })
  },
  beforeDestroy () {
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  }
}
</script>

<style scoped lang="scss">
.ContactUs {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }
        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    padding-left: 50px;
    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;
      img {
        width: 22px;
        height: 20px;
      }
      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }
      span {
        font-size: 16px;
        &:nth-child(1) {
          color: #666666;
        }
        &:nth-child(2) {
          color: #2b8737;
        }
      }
    }
  }
  .ContactUs_box {
    width: 100%;
    height: 756px;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      height: 700px;
      margin-top: 20px;
      padding: 0 28px;
      overflow: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .contentBox_top {
        width: 100%;
        height: 270px;
        display: flex;
        justify-content: space-between;
        .contentBox_topLeft {
          width: 732px;
          height: 270px;
          border: 1px solid #e5e5e5;
          display: flex;
          .zxdh {
            width: 242px;
            height: 270px;
            border-right: 1px solid #e5e5e5;
            padding: 54px 56px 0;
            .zxdh_box {
              width: 130px;
              height: 180px;
              color: #333333;
              li {
                &:nth-child(1) {
                  width: 100%;
                  height: 46px;
                  padding-left: 46px;
                  img {
                    width: 46px;
                    height: 46px;
                  }
                }
                &:nth-child(2) {
                  width: 100%;
                  height: 17px;
                  font-family: Source Han Sans CN;
                  font-weight: 700;
                  font-size: 17px;
                  line-height: 41px;
                  padding-left: 34px;
                }
                &:nth-child(3) {
                  width: 100%;
                  height: 12px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  font-size: 15px;
                  line-height: 77px;
                  padding-left: 10px;
                }
              }
            }
          }
          .gsdz {
            width: 242px;
            height: 270px;
            border-right: 1px solid #e5e5e5;
            padding: 54px 20px 0;
            .gsdz_box {
              width: 204px;
              height: 180px;
              color: #333333;
              li {
                &:nth-child(1) {
                  width: 100%;
                  height: 46px;
                  padding-left: 78px;
                  img {
                    width: 46px;
                    height: 46px;
                  }
                }
                &:nth-child(2) {
                  width: 100%;
                  height: 17px;
                  font-family: Source Han Sans CN;
                  font-weight: 700;
                  font-size: 17px;
                  line-height: 41px;
                  padding-left: 60px;
                }
                &:nth-child(3) {
                  width: 100%;
                  height: 43px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 15px;
                  color: #333333;
                  line-height: 28px;
                  margin-top: 24px;
                }
              }
            }
          }
          .dzyx {
            flex: 1;
            padding: 54px 20px 0;
            .dzyx_box {
              width: 204px;
              height: 180px;
              color: #333333;
              li {
                &:nth-child(1) {
                  width: 100%;
                  height: 46px;
                  padding-left: 78px;
                  img {
                    width: 46px;
                    height: 46px;
                  }
                }
                &:nth-child(2) {
                  width: 100%;
                  height: 17px;
                  font-family: Source Han Sans CN;
                  font-weight: 700;
                  font-size: 17px;
                  line-height: 41px;
                  padding-left: 60px;
                }
                &:nth-child(3) {
                  width: 100%;
                  height: 43px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 15px;
                  color: #333333;
                  line-height: 28px;
                  margin-top: 24px;
                  padding-left: 8px;
                }
              }
            }
          }
        }
        .contentBox_topRight {
          width: 400px;
          height: 270px;
          overflow-y: auto;
          overflow-x: hidden;
          border: 1px solid #e5e5e5;
          &::-webkit-scrollbar {
            width: 6px;
          }
          &::-webkit-scrollbar-track {
            background: #f8f8f8;
            border-radius: 3px;
          }
          &::-webkit-scrollbar-thumb {
            background: #1c7e28;
            border-radius: 3px;
            &:hover {
              background: #15621f;
            }
          }
          li {
            width: calc(100% - 2px);
            margin-left: 1px;
            height: 71px;
            display: flex;
            border-left: 1px solid #e5e5e5;
            border-right: 1px solid #e5e5e5;
            flex-shrink: 0;
            div {
              height: 71px;
              text-align: center;
              line-height: 71px;
              color: #333333;
              &:nth-child(1) {
                width: 133px;
                border-right: 1px solid #e1e1e1;
                border-bottom: 1px solid #e1e1e1;
              }
              &:nth-child(2) {
                width: 133px;
                border-right: 1px solid #e1e1e1;
                border-bottom: 1px solid #e1e1e1;
              }
              &:nth-child(3) {
                width: 134px;
                border-bottom: 1px solid #e1e1e1;
              }
            }
            &:nth-child(1) {
              width: 100% !important;
              height: 56px;
              background-color: #1c7e28;
              display: flex;
              margin-left: 0 !important;
              position: sticky;
              top: 0;
              z-index: 10;
              div {
                height: 56px;
                text-align: center;
                line-height: 56px;
                color: #fff;
                &:nth-child(1) {
                  width: 133px;
                  border-right: none !important;
                  border-bottom: none !important;
                }
                &:nth-child(2) {
                  width: 133px;
                  border-right: none !important;
                  border-bottom: none !important;
                }
                &:nth-child(3) {
                  width: 134px;
                  border-bottom: none !important;
                }
              }
            }
            &:last-child {
              border-bottom: 1px solid #e5e5e5;
              div {
                border-bottom: 1px solid #e1e1e1 !important;
              }
            }
          }
        }
      }
      .contentBox_bottom {
        width: 100%;
        height: 400px;
        min-height: 400px;
        background-color: #f5f5f5;
        position: relative;
        #map {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contactUs/ContactUs.vue